import React from "react";
import qs from "qs";
import FormCliente from "../_Components/FormCliente";
import MasterTemplate from "./MasterTemplate";
import { Link } from 'react-router-dom';

export class MasterCadastroCliente extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
        }
        this.queryString = qs.parse(this.props.location.search, {ignoreQueryPrefix: true})
    }

    render() {
        const tutorId = '';
        const {id} = this.queryString

        return (
            <MasterTemplate label="Cadastrar Cliente">
                        <div className="content">
                            <div className="container-fluid">

                                <div className="row">
                                    <div className="col-md-12 col-lg-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">Cadastro de Clientes</h4>
                                            </div>
                                            <div className="card-body">
                                                <FormCliente perfil="CLIENTE" tutorId={this.state.user._id} id={id} redirect={'master-gerencia-clientes'}  />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
           </MasterTemplate>
        );
    }
}

export default MasterCadastroCliente;
